<template>
    <!-- 跟frontend_ambassador開始有差異，填寫邏輯跟更動主要在那裏，設定邏輯寫在這裡，這裡存在部分填寫但驗證邏輯並不完整 -->
    <Form v-if="values.application_title !== undefined" :schema="schema" :values="values" class="prog-set-form-wrap"
        :class="{ 'is-error': is_error, 'only_view': only_view, 'for-fill-in': type === 'fillin' }" ref="form">
        <svg-icon class="only-view-svg" v-if="only_view" name="close" @click="$emit('close_only_view')" />
        <Scrollbar class="data-list" :show_bar="true" :key="key_refrash">
            <div :class="['logo', only_view && 'logo-only-view']" @click="showUpload=true">
                <i v-if="!only_view" ><svg-icon name="pen"/></i>
                <img v-if="data.preview_logo_image_url" :src="data.preview_logo_image_url "
                    alt="logo">
                <img v-else-if="$store.state.user_data.merchant_account" :src="$store.state.user_data.merchant_account.store_front_logo" alt="logo"/>
            </div>
            <!-- title-box -->
            <div class="from-box title-box">
                <Button :style="'border'" size="24" :border_r="4" @click="editSetting('title')" :flex="true"
                    class="edit-btn"><svg-icon name="pen" />Edit</Button>
                <div class="content">
                    <div v-if="values.application_title" :class="['title', (only_view && !values.summary.val) && 'title-big-only']" :key="key_refrash_left">{{ values.application_title.val }}</div>
                    <div v-if="values.summary" :class="['text', !values.summary.val && 'desc', (only_view && !values.summary.val) && 'title-big-only']">{{ values.summary.val ? values.summary.val : !only_view ? `Click Edit to change program name or summary.`:'' }}
                    </div>
                </div>
            </div>

            <!-- about-us-box -->
            <div class="from-box about-us-box" v-if="values.creator_arr">
                <Button :style="'border'" size="24" :border_r="4" @click="editSetting('creator')" :flex="true"
                    class="edit-btn"><svg-icon name="pen" />Edit</Button>
                <div class="content">
                    <div class="title">{{ creator_title }}</div>
                    <div class="question"
                        v-for="(v, k) in values.creator_arr.filter(e => { return e.show && e.label !== 'last_name' })"
                        :key="k" v-show="v.show">
                        <label :class="['label', v.is_required && 'label-req']">{{ v.name }}</label>
                        <div class="text-light" v-if="v.spec_val">{{ v.spec_val }}</div>

                        <div
                            :class="['field-box', (lastNameValueIndex !== -1 && v.label === 'full_name') && 'field-flex-box']">
                            <Field :type="v.client_type" :k="v.label" :placeholder="v.plac" :had_value="v.val"
                                :date_format="v.plac" :min_date="v.min_date" :max_date="v.max_date"
                                :select_data="v.input_option" :is_disabled="is_edit_setting"
                                :default_date="v.default_date" :error_msg="errors[v.label]"
                                :is_success="success[v.label]" @update="update" :ref="(el) => { els.push(el) }"
                                :spec="'creator_arr'" :dropdown_use="'text'" />
                            <!-- last name要注意位子 -->
                            <Field v-if="lastNameValueIndex !== -1 && v.label === 'full_name'"
                                :type="values.creator_arr[lastNameValueIndex].client_type"
                                :k="values.creator_arr[lastNameValueIndex].label"
                                :placeholder="values.creator_arr[lastNameValueIndex].plac"
                                :had_value="values.creator_arr[lastNameValueIndex].val"
                                :is_disabled="is_edit_setting"
                                :error_msg="errors[values.creator_arr[lastNameValueIndex].label]"
                                :is_success="success[values.creator_arr[lastNameValueIndex].label]" @update="update"
                                :ref="(el) => { els.push(el) }" :spec="'creator_arr'" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- custom-box mighy lot of-->
            <div :class="['from-box custom-box', handleCustomUi(v, 'err') && 'custom-box-err', handleCustomUi(v, 'success') && 'custom-box-success']"
                v-for="(v, k) in values.custom_arr" :key="k">
                <Button :style="'border'" size="24" :border_r="4" @click="editSetting('custom_question', v)"
                    :flex="true" class="edit-btn"><svg-icon name="pen" />Edit</Button>
                <div class="content content-cus">
                    <div class="question">
                        <label :class="['label', v.is_required && 'label-req']">{{ v.label }}</label>
                        <br/><label class="label-text" v-if="v.client_type==='multi_select' || v.client_type==='single_select'">{{ v.name_type }}:</label>

                        <Field :type="v.client_type" :k="v.label" :placeholder="v.plac" :had_value="v.val"
                            :is_disabled="is_edit_setting" :select_data="v.input_option" :max_value="v.max_value"
                            :error_msg="errors[v.label]" :is_success="success[v.label]" @update="update"
                            :ref="(el) => { els.push(el) }" :spec="'custom_arr'" />
                    </div>
                </div>
            </div>

            <!-- btn-box -->
            <div class="btn-box" v-if="!only_view && type !== 'fillin'">
                <div class="editList" v-if="open_list_val.val" :class="'menu-type-' + menu_type" ref="el">
                    <div class="tit">Form</div>
                    <div class="item" v-for="(item, index) in open_list_val.list" :key="index"
                        @click.stop="selectType(open_list_val.type, index)" v-show="!item.is_add">
                        <span>{{ item.text }} </span>
                        <!-- {{open_list_val.type}} - {{index}} -->
                    </div>
                </div>
                <Button color="black-60" size="40" :border_r="6" :flex="true" :style="'border-square'" v-if="values.custom_arr.length < custom_question_val.max"
                    @click.stop="openList('cus')"><svg-icon name="plus" />Custom Question({{ values.custom_arr.length }}/{{ custom_question_val.max }})</Button>
                <!-- <Button color="black-60" size="40" :border_r="6" :flex="true" :style="'border-square'" @click.stop="openList('sec')"><svg-icon name="plus" />New Sections</Button> -->
                <!-- <Button v-if="sections_val.list.find(item => (item.id === 1 && !item.is_add))" color="black-60" size="40" :border_r="6" :flex="true" :style="'border-square'" @click.stop="selectType(2, 1)"><svg-icon name="plus" />Social Section</Button>
                <Button v-if="sections_val.list.find(item => (item.id === 0 && !item.is_add))" color="black-60" size="40" :border_r="6" :flex="true" :style="'border-square'" @click.stop="selectType(2, 0)"><svg-icon name="plus" />Parent / Guardian Consent Sections</Button> -->
                <Button  v-for="(item, index) in sections_val.list" :key="index"
                v-show="!item.is_add" 
                color="black-60" size="40" :border_r="6" :flex="true" 
                :style="'border-square'" @click.stop="selectType(2, index)"
                ><svg-icon name="plus" />{{ item.text }}</Button>
                
            </div>

            <!-- parent-box-->
            <div class="from-box parent-box" v-if="blockShow.parent">
                <Button :style="'border'" size="24" :border_r="4" @click="editSetting('parent_guardian_consent')"
                    :flex="true" :class="['edit-btn',(parent_value.edit_err && type !=='create') && 'err-edit-btn']"><svg-icon name="pen" />Edit</Button>
                <div class="content">
                    <div class="title">Parent / Guardian Consent</div>
                    <div class="desc desc-text" v-if="parent_value.desc_open">{{ parent_value.int }}</div>

                    <div class="question"
                        v-for="(v, k) in values.parent_arr.filter(e => { return e.group_label !== 'parent_guardian_consent_disclaimer_confirm' && e.label !== 'parent_guardian_introduction' && e.tag!=='for_url'})"
                        :key="k">
                        <label :class="['label', v.is_required && 'label-req']">{{ v.name }}</label>
                        <Field :type="v.client_type" :k="v.label" :placeholder="v.plac" :had_value="v.val"
                            :date_format="v.plac" :min_date="v.min_date" :max_date="v.max_date"
                            :is_disabled="is_edit_setting" :default_date="v.default_date" :error_msg="errors[v.label]"
                            :is_success="success[v.label]" @update="update" :ref="(el) => { els.push(el) }"
                            :spec="'parent_arr'" />
                    </div>
                    <div :class="['term-box', parent_value.term_err_mes && 'term-box-err']">
                        <div class="text flex">Please read our Parental/Guardian Consent Disclaimer and confirm the
                            following:<div class="red">*</div>
                        </div>
                        <div class="checkbox-box"
                            v-for="(v, k) in values.parent_arr.filter(e => { return e.group_label === 'parent_guardian_consent_disclaimer_confirm' })"
                            :key="k" @click="hanleCheckbox(v)">
                            <Checkbox :checked="v.val" />
                            <div class="text" v-html="v.name"></div>
                        </div>
                        <div class="err-mes" v-if="parent_value.term_err_mes">
                            {{ parent_value.term_err_mes }}<svg-icon name="alert" class="icon-left" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Social Accounts-->
            <div class="from-box social-box" v-if="blockShow.social">
                <Button :style="'border'" size="24" :border_r="4" @click="editSetting('social_account')" :flex="true"
                    class="edit-btn"><svg-icon name="pen" />Edit</Button>
                <div class="content social-box-content">
                    <div class="title">Social Accounts</div>
                    <div class="desc desc-text" v-if="social_value.desc_open">{{ values.social_account_arr.some(e=> e.client_type === 'connect') ? ` You must connect either your Instagram or TikTok.`:`You must enter either your Instagram or TikTok.`}}</div>
                    <div class="question" v-for="(v, k) in values.social_account_arr" :key="k">
                        <div class="item-box" v-if="v.show">
                            <div class="line-box">
                                <div :class="['label', v.is_required && 'label-req']"><svg-icon v-if="v.icon"
                                        :name="v.icon" />{{ v.name }}</div>
                                <Button v-if="v.client_type === 'connect'" class="connet-btn" size="32"
                                    :style="!v.val ? 'bg' : 'border-square'" :color="!v.val ? 'dark-blue' : 'black-60'"
                                    :border_r="6" >
                                    {{ !v.val ? 'Connect' : 'Connected' }}
                                </Button>

                                <div class="for-you-url-box"
                                    v-if="v.client_type === 'url' || v.client_type === 'url-handle'">
                                    <Field type="text" :k="v.label" :placeholder="v.plac" :had_value="v.val"
                                        :is_disabled="is_edit_setting" :error_msg="errors[v.label]"
                                        :is_success="success[v.label]" @update="update" :ref="(el) => { els.push(el) }"
                                        :spec="'social_account_arr'" />
                                </div>
                            </div>

                        </div>
                        <div class="err-mes" v-if="social_value.connet_err_mes && v.label === 'instagram'">
                            {{ social_value.connet_err_mes }}<svg-icon name="alert" class="icon-left" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- term-box-->
            <div class="from-box term-box"
                v-if="values.agreements_disclaimers_arr && values.agreements_disclaimers_arr.length > 0">
                <Button :style="'border'" size="24" :border_r="4" @click="editSetting('agreements_disclaimers')"
                    :flex="true" :class="['edit-btn',(term_value.edit_err && type !=='create') && 'err-edit-btn']"><svg-icon name="pen" />Edit</Button>
                <div :class="['content', (term_value.term_err_mes) && 'term-box-err']">
                    <div class="text trem-text" v-for="(v, k) in values.agreements_disclaimers_arr" :key="k"
                        v-show="v.show">
                        <div class="trem-text-check-box checkbox-box" @click="hanleCheckbox(v)">
                            <Checkbox :checked="type === 'fillin' ? v.val : false" :value="k"
                                :disabled="is_edit_setting" />
                            <p v-html="v.name"></p>
                        </div>
                    </div>
                    <div class="err-mes" v-if="term_value.term_err_mes">
                        {{ term_value.term_err_mes }}<svg-icon name="alert" class="icon-left" />
                    </div>
                </div>
            </div>
            <Button class="submit-btn" color="dark-blue" size="40" :border_r="6" @click="submit" :is_disabled="!is_can_save">{{ only_view ||
        type === 'fillin' ? 'Submit' : 'Save' }}</Button>
        </Scrollbar>
    </Form>
    <!-- edit_popup -->
    <ProgTitleEdit v-if="edit_value.title" :data="handle_data.basic" :is_show="edit_value.title"
        @close="edit_value.title = false" @save="saveSetting"/>

    <ProgCreatorEdit v-if="edit_value.creator" :data="handle_data.basic" :is_show="edit_value.creator"
        :porgram_for_who="porgram_for_who" @close="edit_value.creator = false;checkIfTerm()" @save="saveSetting" :type="type" :is_copy="is_copy"  :other_data="data"/>

    <Modal :is_show="edit_value.parent_guardian_consent" @click-bg="edit_value.parent_guardian_consent = false" class="add-creator-modal add-parent-modal edit-program-set-pop">
        <ProgParentEdit v-if="edit_value.parent_guardian_consent" :data="handle_data.parent_guardian_consent" @close="edit_value.parent_guardian_consent = false"
            @save="saveSetting" @hide="sections_val.list[sections_val.parent_id].is_add = false; hideNot();" :pro_title="values.application_title.val"/>
    </Modal>


    <ProgSocialEdit v-if="edit_value.social_account" :data="handle_data.social_account"
        :is_show="edit_value.social_account" @close="edit_value.social_account = false" @save="saveSetting"
        @hide="sections_val.list[sections_val.social_id].is_add = false;hideNot();" />

    <ProgCustomEdit v-if="edit_value.custom_question" :key="cus_key_refrash" :data="get_cus_value" :is_can_delete="is_can_delete"
        :is_show="edit_value.custom_question" @close="edit_value.custom_question = false" @save="saveSetting"
        @del="delCustom" />

    <ProgAgreementEdit v-if="edit_value.agreements_disclaimers" :data="handle_data.agreements_disclaimers"
        :is_show="edit_value.agreements_disclaimers" @close="edit_value.agreements_disclaimers = false"
        @save="saveSetting" :brand_name="brand_name" />
    
    <UploadAvatar save_button_text="Next" @save="saveImage" v-if="showUpload" @closeModal="closeLogoModal" :img_url="data.preview_logo_image_url">
        <template #desc>
            <div class="desc">The default logo is currently set to the one from your portal settings. This doesn’t have to match the portal logo. <span class='blue'>Click here </span> to reset to the default logo.
                <br/><br/>
                Please upload a PNG image (max size: 200KB). Recommend to use PNG image with transparent background.
            </div>
        </template>
    </UploadAvatar>

</template>

<script>
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import ProgCreatorEdit from './ProgCreatorEdit.vue';
import ProgTitleEdit from './ProgTitleEdit.vue';
import ProgParentEdit from './ProgParentEdit.vue';
import ProgCustomEdit from './ProgCustomEdit.vue';
import ProgAgreementEdit from './ProgAgreementModal.vue';
import ProgSocialEdit from './ProgSocialEdit.vue';
import UploadAvatar from '@/components/UploadAvatar.vue';
import * as yup from 'yup';
import moment from 'moment';
import { getIndex, CustomQuestion, FromSettingYup, CustomYupRules, blockStatus, handleParentUrl } from '@/utils/ProgramsData.js';


export default {
    name: 'ProgramForm',
    emits: ['close_only_view', 'update-data', 'save-form','handle_old_data'],
    data() {
        return {
            values: {},
            handle_data: {},
            els: [],
            is_error: false,
            is_disabled_click: false,
            schema: yup.object().shape({}),
            errors: {},
            success: {},
            edit_value: {
                title: false,
                creator: false,
                parent_guardian_consent: false,
                social_account: false,
                custom_question: false,
                agreements_disclaimers: false,
            },
            open_list_val: {
                val: false,
                type: 1,//1.Question type2.Section type
                title: 'Question type',
                list: [],
            },
            sections_val: {
                title: 'Section type',
                parent_id: 0,
                social_id: 1,
                list_value: [
                    { text: 'Parent / guardian consent', id: 0, is_add: false, can_edit: false, type: 'parent', field: 'parent_guardian_consent' },
                    { text: 'Social accounts', id: 1, is_add: false, can_edit: false, type: 'social', field: 'social_account' },
                ],
                list: [
                    { text: 'Parent / guardian consent', is_add: false, id: 0, field: 'parent_guardian_consent' },
                    { text: 'Social accounts', is_add: false, id: 1, field: 'social_account' },
                ],
            },
            custom_question_val: {
                title: 'Custom Question',
                list: [
                    { text: 'Single select question', id: 0 },
                    { text: 'Multiple select question', id: 1 },
                    { text: 'Short answer question', id: 2 },
                    { text: 'Long answer question', id: 3 },
                ],
                max:6
            },
            get_cus_value: {},
            parent_value: {
                int: ``,
                desc_open: false,
                term_err_mes: '',
                edit_err:'',
            },
            social_value: {
                desc_open: false,
                connet_err_mes: '',
            },
            custom_value: {
                is_new: false,
            },
            term_value: {
                term_err_mes: '',
                edit_err:false,
            },
            key_refrash: 0,
            cus_key_refrash: 0,
            menu_type: '',
            is_can_delete: false,
            showUpload:false,
        }
    },

    props: {
        data: {
            type: Object,
            default: {}
        },
        type: {
            type: String,
            default: 'create',//create,edit,fillin
        },
        othet_data: {
            type: Object,
            default: {}
        },
        is_edit_setting: {
            type: Boolean,
            default: false,
        },
        only_view: {
            type: Boolean,
            default: false,
        },
        porgram_for_who: {
            type: [String, Number],
            default: 0,
        },
        is_copy:{
            type: Boolean,
            default: false,
        },
        key_refrash_left:{
            type: [String, Number],
            default: 0,
        },

        key_refrash_left_country:{
            type: [String, Number],
            default: 0,
        },

        is_first_create:{
            type: Boolean,
            default: false,
        },

        is_can_save:{
            type: Boolean,
            default: false,
        }
    },

    computed: {
        brand_name() {
            return this.$store.state.user_data && this.$store.state.user_data.merchant_account && this.$store.state.user_data.merchant_account.merchant_display_name;
        },
        brand_id() {
            return this.$store.state.user_data && this.$store.state.user_data.merchant_account && this.$store.state.user_data.merchant_account.id;
        },
        program_title(){
            let index = getIndex(this.handle_data.basic, 'title', 'application_title');
            return this.handle_data.basic[index.i].question[index.ii].client_view.val;
        },

        creator_title(){
            let index = getIndex(this.handle_data.basic, 'tell_us_about_yourself_title', 'tell_us_about_yourself_title');
            if(this.handle_data.basic[index.i].can_edit){
                return this.handle_data.basic[index.i].question[index.ii].client_view.val;
            }else{
                return 'Tell Us About Yourself...'
            }
        },

        // shouldSecBtnShow() {
        //     const allAdd = this.sections_val.list.every(item => item.is_add);
        //     return !allAdd;
        // },

        lastNameValueIndex() {
            return this.values.creator_arr.findIndex(e => { return e.label === 'last_name' })
        },

        blockShow() {
            let is_fillin = this.type === 'fillin';
            return {
                parent: (this.sections_val.parent_id !== -1 && this.sections_val.list[this.sections_val.parent_id].is_add) || (is_fillin && this.handle_data.parent_guardian_consent.length > 0),
                social: (this.sections_val.social_id !== -1 && this.sections_val.list[this.sections_val.social_id].is_add) || (is_fillin && this.handle_data.social_account.length > 0)
            }
        }

    },

    components: {
        Scrollbar,
        Field,
        Button,
        Form,
        Checkbox,
        Modal,
        NoData,
        Loading,
        Dropdown,
        ProgTitleEdit,
        ProgCreatorEdit,
        ProgParentEdit,
        ProgCustomEdit,
        ProgAgreementEdit,
        ProgSocialEdit,
        UploadAvatar,
    },

    watch: {
        key_refrash_left(val){
            if(val){
                let new_title=this.data.basic[0].question[0].client_view.val;
                this.handle_data.basic[0].question[0].client_view.val = new_title;
                this.values.application_title.val = new_title;
            }
        },

        key_refrash_left_country(val){
            if(val){
                let index = getIndex(this.data.basic, 'country_location', 'country_location');
                let new_val=this.data.basic[index.i].is_required;
                this.handle_data.basic[index.i].is_required = new_val;
                this.handle_data.basic[index.i].is_switch = new_val;
               
                this.createValuesAndSchema(this.handle_data);
            }
        }

    },

    methods: {
        createUUID() {
            return 'xxxxxxxx'.replace(/[x]/g, function (c) {
                var r = Math.random() * 16 | 0;
                return r.toString(16);
            });
        },

        editSetting(val, get_val) {

            if (this.only_view || this.type === 'fillin') {
                return
            }

            this.edit_value[val] = true;
            if (val === 'custom_question') {
                this.is_can_delete = true;
                let index = this.handle_data.custom_question.findIndex(item => item.cus_id === get_val.cus_id);
                this.get_cus_value = this.handle_data.custom_question[index];
                this.custom_value.is_new = false;
                this.edit_value.custom_question = true;
            } else {
                this.is_can_delete = false;
            }
        },

        //編輯設定才會觸發
        saveSetting(val) {
            if (val.type === 'creator' || val.type === 'title') {
                let copy = val.data;
                this.handle_data.basic = copy;
                this.$emit('update-data', { field: val.type, val: val.data, ambassador_application_template_id: val.ambassador_application_template_id })

            } else if (val.type === 'custom_question') {
                if (this.custom_value.is_new === true) {
                    val.data.cus_id = this.createUUID();
                    val.data.is_new= true;
                    this.handle_data[val.type].push(val.data);
                } else {
                    for (let i = 0; i < this.handle_data[val.type].length; i++) {
                        if (this.handle_data[val.type][i].cus_id === val.data.cus_id) {
                            this.handle_data[val.type][i] = val.data;
                            break;
                        }
                    }
                }
                this.$emit('update-data', { field: val.type, val: this.handle_data[val.type]})
            
            } else {
                this.handle_data[val.type] = val.data;
                this.$emit('update-data', { field: val.type, val: val.data})
            };

            if(val.type === 'agreements_disclaimers'){
                this.term_value.edit_err=false;
            }

            if(val.type === 'parent_guardian_consent'){
                this.parent_value.edit_err=false;
            }

            this.createValuesAndSchema(this.handle_data);
            this.edit_value[val.type] = false;

            //關閉選擇給哪種使用者(basic)的編輯要查找handle_data是否有term需要填寫
            if (val.type === 'creator' && !val.ambassador_application_template_id  ){
                this.checkIfTerm();
            }
            this.key_refrash += 1;
        },

        saveImage(){

        },

        checkIfTerm(){
            //關閉選擇給哪種使用者(basic)的編輯要查找handle_data是否有term需要填寫
            if (this.values.agreements_disclaimers_arr.length > 0 ){
                let hasEmptyUrl = this.values.agreements_disclaimers_arr.some(e => e.url === '');
                if(hasEmptyUrl){
                    this.editSetting('agreements_disclaimers');
                }
            }
        },

        getData() {
            // console.log('this.data', this.data)

            //第一次創建將basic edit打開
            if(this.is_first_create){
                this.editSetting('creator');
            }
            
            this.handle_data = JSON.parse(JSON.stringify(this.data));

            //parent handle text
            handleParentUrl(this.handle_data.parent_guardian_consent, this.brand_name, this.program_title);

            this.handleDiffrentTemplate();
            this.handleBlockOpen();
            this.createValuesAndSchema(this.handle_data);

            //因為整理的時候資料結構會變動，所以偷吃不讓整理過的資料先傳出去
            setTimeout(()=>{
                this.$emit('handle_old_data',{handle_data:this.handle_data,block:this.sections_val.list,tip:'old'});
            },100)
        },

        handleDiffrentTemplate() {
            this.sections_val.list_value[0].can_edit = this.handle_data.parent_guardian_consent && this.handle_data.parent_guardian_consent.length > 0;
            this.sections_val.list_value[1].can_edit = this.handle_data.social_account && this.handle_data.social_account.length > 0;
            this.sections_val.list = this.sections_val.list_value.filter(e => e.can_edit);
            this.sections_val.parent_id = this.sections_val.list.findIndex(item => item.type === 'parent');
            this.sections_val.social_id = this.sections_val.list.findIndex(item => item.type === 'social');
        },

        handleBlockOpen() {
            if (this.handle_data.block_status) {
                this.sections_val.list.forEach(e => {
                    const item = this.handle_data.block_status.find(ee => ee.name === e.field);
                    if (item) {
                        e.is_add = item.open;
                    }
                })
            }
        },

        //++++++++++++++++++++++++++++++++++++
        //for fiil in function
        //++++++++++++++++++++++++++++++++++++

        handleCustomUi(v, type) {
            let check_field = (v.tag === 'add_single_select_question' || v.tag === 'add_multiple_select_question');
            if (type === 'err') {
                return this.errors[v.label] && check_field;
            } else {
                return this.success[v.label] && check_field;
            }
        },

        //++++++++++++++++++++++++++++++++++++++++++
        //!!!!makeing all data here....!!!
        //++++++++++++++++++++++++++++++++++++++++++
        createValuesAndSchema(formSetting) {
            
            let values = {
                creator_arr: [],
                parent_arr: [],
                social_account_arr: [],
                required_at_least_1: [],
                custom_arr: [],
                agreements_disclaimers_arr: [],
            };
            let schemaShape = {};

            const handleAllData = (question, group) => {
                //如果群組打開
                if (group.is_switch) {

                    if (question.hasOwnProperty('is_switch') && question.client_view) {
                        question.client_view.show = question.is_switch;
                        question.show= question.is_switch;
                    }
                    //群組如果打開，並且沒有自己的操作欄位，那question index 0的show一定為true
                    else if(question.index===0){
                        question.client_view.show = group.is_switch;
                        question.show= group.is_switch;
                    }
                }
                //如果群組關閉，所有question都不show出
                else {
                    group.is_required=false;
                    if (question.client_view) {
                        question.client_view.show = false;
                    }
                }

                //拼回驗證
                if (question.client_view) {
                    const label = question.label;
                    if (FromSettingYup[label]) {
                        question.client_view.yup_rule = FromSettingYup[label];
                    }
                }

                return question;
            }

            const handleAllRequired = ( group, question ) => {

                if (group.setting_number===1) { //一定必填
                    group.is_switch = true;
                    group.is_required = true;
                } else if (group.is_required === undefined) { //檢查是否有自己操控必填，如果沒有那就加上必填欄位為false
                    group.is_required = false;
                }
                
                //判定question必填
                //(question的index=0會跟著父層的is_required走，其他基本上獨立)
                if(question){
                    if (group.hasOwnProperty('is_required') && question.client_view && question.index === 0) {
                        question.client_view.is_required = group.is_required;
                    }else if(question.client_view){
                        
                        if(question.client_view.setting_number===1){
                            question.client_view.is_required = true;
                        }else if(question.client_view.setting_number===2){//如果自己沒有操控的is_required,跟著父曾走
                            question.client_view.is_required = group.is_required 
                        }//剩下都是自己控制自己的必填
                    }
                } 
            }

            const handleAllScem = (question) => {
                if (question.client_view && question.client_view.yup_rule && question.client_view.show) {
                    schemaShape[question.label] = question.client_view.yup_rule;
                    const required = schemaShape[question.label].required;
                    if (question.client_view.is_required && schemaShape[question.label] && typeof required === 'function') {
                        let name = question.client_view.title ? question.client_view.title : question.client_view.name;
                        schemaShape[question.label] = schemaShape[question.label].required(`The ${name} can’t be left blank`);
                    }
                }
            }

            //basic
            formSetting.basic.forEach(group => {
                
                group.question.forEach(question => {
                    //-----------------------------------------
                    //for all
                    //-----------------------------------------
                    handleAllData(question, group);
                    handleAllRequired(group,question);
                    //-----------------------------------------
                    //for special field
                    //-----------------------------------------
                    if (group.group_name === "address" && question.label === 'address_placeholder') {
                        question.client_view.spec_val = group.question[1].val;
                    }

                    if (group.group_name === "date_of_birth" && question.label === 'date_of_birth') {
                        question.client_view.plac = group.question[1].can_edit ? group.question[1].val : question.client_view.plac;//編輯的時候後端部會傳group.question[2]給前端
                        question.client_view.max_date = null//new Date(new Date().setFullYear(new Date().getFullYear() - group.question[1].val));
                        question.client_view.default_date = question.client_view.max_date ? question.client_view.max_date : '';

                        if (this.$ProjectName === 'sephora') {
                            // remove year from date_of_birth P42-10308
                            if (question.input_type === 'toggle') question.client_view.plac = question.client_view.plac.replace(/\/YYYY|YYYY\//g, '');

                            if (question.input_type === 'single_select') {
                                question.input_value = question.val.replace(/\/YYYY|YYYY\//g, '');
                                question.val = question.val.replace(/\/YYYY|YYYY\//g, '');
                                question.input_option.forEach(e => {
                                    // Remove /YYYY or YYYY/ from date formats
                                    e.text = e.text.replace(/\/YYYY|YYYY\//g, '');
                                });
                            }
                        }
                    }

                    //-----------------------------------------
                    //push data
                    //-----------------------------------------
                    if (group.group_name === "title" || group.group_name === "summary" || group.group_name === "tell_us_about_yourself_title" && group.can_edit ) {
                        values[question.label] = question.client_view;
                    } else if (question.client_view && group.can_edit && question.can_edit && question.client_view.show) {
                        let client_view = {
                            ...question.client_view,
                            label: question.label,
                        };

                        values.creator_arr.push(client_view);
                    }

                    //makeing schema here....
                    if (group.can_edit && question.can_edit) {
                        handleAllScem(question);
                    }
                });
            });

            //parent
            formSetting.parent_guardian_consent.forEach(group => {

                group.question.forEach(question => {
                    //-----------------------------------------
                    //for all
                    //-----------------------------------------
                    handleAllData(question, group);
                    handleAllRequired(group,question);
                    //-----------------------------------------
                    //for special field
                    //-----------------------------------------
                    if (group.group_name === "parent_guardian_introduction") {
                        this.parent_value.desc_open = group.is_switch;
                    }
                    if (group.group_name === "parent_guardian_introduction" && question.label === 'parent_guardian_introduction') {
                        this.parent_value.int = question.client_view.val ? question.client_view.val : question.client_view.plac;
                    }

                    //-----------------------------------------
                    //push data
                    //-----------------------------------------
                    if (question.client_view && question.can_edit && question.client_view.show) {
                        let client_view = {
                            ...question.client_view,
                            label: question.label,
                            group_label:group.group_name,
                            tag:group.tag
                        };

                        values.parent_arr.push(client_view);
                        //makeing schema here....
                        handleAllScem(question);
                    }

                });
            });

            //---------------------------------------------
            //spcial to do
            //social_account_arr
            //---------------------------------------------
            formSetting.social_account.forEach(group => {
                handleAllRequired(group);
                if (group.group_name === 'required_at_least_1') {
                    this.social_value.desc_open = group.is_required;
                }
                if (group.connect && group.can_edit) {
                    group.connect.client_view = {
                        ...group.connect.client_view,
                        show: group.is_switch,
                        is_required: group.is_switch && group.is_required,//social的必填會看父曾，不看question內部
                        label: group.group_name,
                    }
                    //放驗證
                    if (FromSettingYup[group.group_name]) {
                        group.connect.client_view.yup_rule = FromSettingYup[group.group_name];
                    }

                    values.social_account_arr.push(group.connect.client_view);

                    //驗證另外處理
                    if (group.connect.client_view.show) {
                        schemaShape[group.group_name] = group.connect.client_view.yup_rule;
                        const required = schemaShape[group.group_name].required;
                        if (group.connect.client_view.is_required && schemaShape[group.group_name] && typeof required === 'function') {
                            let name = group.connect.client_view.name;
                            schemaShape[group.group_name] = schemaShape[group.group_name].required(`The ${name} can’t be left blank`);
                        }
                    }
                } else {
                    values.required_at_least_1 = group;
                }
            });

            //-------------------------------------
            //custom question
            //-------------------------------------
            formSetting.custom_question.forEach((group, k) => {
                if (group.client_view) {
                    //拼回驗證
                    if (CustomYupRules[group.label]) {
                        group.client_view.yup_rule = CustomYupRules[group.label];
                    }

                    let client_view = {
                        ...group.client_view,
                        id: k,
                        type_id: group.id,
                        cus_id: group.cus_id,
                        max_value: group.max_value,
                        tag: group.label,
                        show: true,
                    };

                    values.custom_arr.push(client_view);

                    //makeing schema here....
                    if (group.client_view.yup_rule) {
                        schemaShape[client_view.label] = client_view.yup_rule;
                        const yupDescription = schemaShape[client_view.label].describe();
                        const hasRequired = yupDescription.tests.some(test => test.name === 'required');

                        if (client_view.is_required && schemaShape[client_view.label] && !hasRequired) {
                            let name = client_view.label;
                            schemaShape[client_view.label] = schemaShape[client_view.label].required(`The ${name} can’t be left blank`);
                        }
                    }
                }

            });

            //agreements_disclaimers
            formSetting.agreements_disclaimers.forEach(group => {
                
                group.question.forEach(question => {
                    //-----------------------------------------
                    //for all
                    //-----------------------------------------
                    handleAllData(question, group);
                    handleAllRequired(group,question);
                    //-----------------------------------------
                    //for special field
                    //-----------------------------------------
                    let isMacy=false;
                    if (window.location.host === 'www.anchor.motom.me' || window.location.host === 'anchor.motom.me'){
                        isMacy= this.brand_id === 106;
                    }else{
                        isMacy= this.brand_id === 56;
                    }

                    if (question.label === 'i_confirm_that_i_am_18_years_or_older' && !question.is_switch) {
                        question.client_view.show = false;
                    } else if (question.client_view) {
                        question.client_view.show = true;
                    };

                    if (question.label === 'i_have_read_and_acknowledge_privacy_policy') {
                        
                        question.url=question.url?question.url:'';
                        if(isMacy){
                            question.client_view.name = `By continuing, you agree that you are subject to ${question.url ? `<a href="${question.url}" class="link" target="_blank">Influencer Notice of Privacy Practices</a>` : `Influencer Notice of Privacy Practices`}.`;
                            question.client_view.desc = `By continuing, you agree that you are subject to “Influencer Notice of Privacy Practices.`
                        }else{
                            question.client_view.name = `I have read and acknowledge the ${this.brand_name} ${question.url ? `<a href="${question.url}" class="link" target="_blank">Privacy Policy</a>` : `Privacy Policy`}.`;
                            question.client_view.desc = `I have read & acknowledge the ${this.brand_name} Privacy Policy.`
                        }
                    }

                    if (question.label === 'i_have_read_and_acknowledge_terms_and_conditions') {
                        question.url=question.url?question.url:'';
                        if(isMacy){
                            question.client_view.name = `By continuing, you agree that you are subject to the ${question.url ? `<a href="${question.url}" class="link" target="_blank">Influencer Legal Notice</a>`:'Influencer Legal Notice'}.`;
                            question.client_view.desc = `By continuing, you agree that you are subject to the Influencer Legal Notice.`
                        }else{
                            question.client_view.name = `I have read and agree to the ${this.brand_name} ${question.url ? `<a href="${question.url}" class="link" target="_blank">Terms & Conditions</a>` : `Terms & Conditions`}.`;
                            question.client_view.desc = `I have read & agree to the ${this.brand_name} Terms & Conditions.`
                        }
                    }

                    //-----------------------------------------
                    //push data
                    //-----------------------------------------
                    if (question.client_view && question.can_edit) {
                        let client_view = {
                            ...question.client_view,
                            label: question.label,
                            url:question.url,
                        };

                        values.agreements_disclaimers_arr.push(client_view);
                        //makeing schema here....
                        handleAllScem(question);
                    }

                });
            });

            //makeing schema here....
            this.schema = yup.object().shape(schemaShape);
            this.values = values;

        },

        //this.handle_data塞回this.values的值用的
        updateFormSettingWithValues() {
            const updateValues = (question, valuesGroup) => {
                const value = valuesGroup.find(v => v.label === question.label);
                if (value && question.client_view) {
                    question.client_view.val = value.val || value.default_val || '';
                }
            };

            // Update basic
            this.handle_data.basic.forEach(group => {
                group.question.forEach(question => {
                    if (this.values[question.label]) {
                        question.client_view.val = this.values[question.label].val || this.values[question.label].default_val || '';
                    }
                    updateValues(question, this.values.creator_arr);
                });
            });

            // Update parent_guardian_consent
            this.handle_data.parent_guardian_consent.forEach(group => {
                group.question.forEach(question => {
                    updateValues(question, this.values.parent_arr);
                });
            });

            // Update social_account
            this.handle_data.social_account.forEach(group => {
                if (group.connect && this.values.social_account_arr.length > 0) {
                    const value = this.values.social_account_arr.find(v => v.label === group.group_name);
                    if (value) {
                        group.connect.client_view.val = value.val || value.default_val || '';
                    }
                }
            });

            // Update custom_question
            this.handle_data.custom_question.forEach(group => {
                const value = this.values.custom_arr.find(v => v.tag === group.label);
                if (value) {
                    group.client_view.val = value.val || value.default_val || '';
                }
            });

            // Update agreements_disclaimers
            this.handle_data.agreements_disclaimers.forEach(group => {
                group.question.forEach(question => {
                    updateValues(question, this.values.agreements_disclaimers_arr);
                });
            });

            // Update other sections if needed
            // Add any additional sections that need to be updated based on the structure of formSetting
        },
        //++++++++++++++++++++++++++++++++++++++++++
        //設定不會用到
        update(obj) {
            this.is_error = false;
            this.error_msg = '';
            if (obj.spec) {
 
            } else {
                Object.keys(this.values).forEach(key => {
                    if (key === obj.key) {
                        if (key === obj.key) this.values[key].val = obj.val;
                    }
                });
            };

        },

        hanleCheckbox(v) {
            if (this.type === 'fillin') {
                v.val = !v.val;
            }
        },

        hideNot(){
            this.$emit('handle_old_data',{handle_data:this.handle_data,block:this.sections_val.list,tip:'new'});
            this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Section hidden.`);
        },

        //++++++++++++++++++++++++++++++++++++++++++
        //saveing 驗證太複雜所以這邊另外客製一個驗證給他，social_account和custom要特別注意(frontend_ambassador在使用)
        //++++++++++++++++++++++++++++++++++++++++++
        async specValidate() {
            this.errors = {};
            this.success = {};
            // console.log('this.values', this.values)

            // 動態處理 yup schema
            const schemaShape = Object.keys(this.values).reduce((acc, key) => {
                if (Array.isArray(this.values[key])) {
                    this.values[key].forEach(item => {
                        if (item.show) {  //  item.show  true 才驗證
                            acc[item.label] = this.schema.fields[item.label];
                        }
                    });
                } else {
                    if (this.values[key].show) {  // 才驗證
                        acc[key] = this.schema.fields[key];
                    }
                }
                return acc;
            }, {});

            // 使用动态构建的 schema
            const dynamicSchema = yup.object().shape(schemaShape);

            // 開新的 values 來驗證
            const validationValues = Object.keys(this.values).reduce((acc, key) => {
                if (Array.isArray(this.values[key])) {
                    this.values[key].forEach(item => {
                        if (item.show) {
                            acc[item.label] = item.val;
                        }
                    });
                } else {
                    acc[key] = this.values[key].val;
                }
                return acc;
            }, {});

            try {
                //social的tk和ig會友只要二選一的狀況，在送出後要另外攔截檢查
                await dynamicSchema.validate(validationValues, { abortEarly: false });

                // 設置成功
                Object.keys(validationValues).forEach(key => {
                    this.success[key] = true;
                });

                return true;

            } catch (err) {
                // 紀錄第一個出的錯
                const firstErrorPaths = new Set();

                err.inner.forEach((error) => {
                    if (!firstErrorPaths.has(error.path)) {
                        this.errors[error.path] = error.message;
                        firstErrorPaths.add(error.path);
                    }
                });

                //部分多欄位在UI上只會顯示一個錯誤，這邊要攔截下來顯示
                this.values.parent_arr.some(e => {
                    if (e.tag === 'term' && this.errors[e.label]) {
                        this.parent_value.term_err_mes = 'Please confirm our Parental/Guardian Consent Disclaimer and confirm the following.';
                        return true; // 终止
                    }
                    return false;
                });

                this.values.agreements_disclaimers_arr.some(e => {
                    if (e.tag === 'term' && this.errors[e.label]) {
                        this.term_value.term_err_mes = 'Please confirm these.';
                        return true; // 终止
                    }
                    return false;
                });

                // 新增检查没有错误的情况
                if (!this.values.parent_arr.some(e => e.tag === 'term' && this.errors[e.label])) {
                    this.parent_value.term_err_mes = '';
                }

                if (!this.values.agreements_disclaimers_arr.some(e => e.tag === 'term' && this.errors[e.label])) {
                    this.term_value.term_err_mes = '';
                }

                this.specSocialValidate();

                // 每個成功狀態
                Object.keys(validationValues).forEach(key => {
                    this.success[key] = !this.errors[key] ? true : false;
                });

                return false;
            }
        },

        specSocialValidate() {
            if (this.social_value.desc_open) {
                const hasNonEmptyVal = this.values.social_account_arr.some(e => e.tag === 'connet' && e.val);
                
                this.social_value.connet_err_mes = hasNonEmptyVal 
                    ? '' 
                    : 'You must connect either your Instagram or TikTok';
            }
        },

        //editing有必填選項
        checkEditing(){
            //agreements_disclaimers
            this.term_value.edit_err = false;
            if(this.handle_data.agreements_disclaimers && this.handle_data.agreements_disclaimers.length > 0){
                this.handle_data.agreements_disclaimers.forEach(e=>{
                    e.question.forEach(qes=>{
                        if(qes.label==='privacy_policy_url' || qes.label==='terms_and_conditions_url'){
                            if(!qes.val){
                                this.term_value.edit_err=true;
                            }
                        }
                    })
                })
            };
   
            //parent_guardian_consent
            this.parent_value.edit_err = false;
            if(this.handle_data.parent_guardian_consent && this.handle_data.parent_guardian_consent.length > 0){
                this.handle_data.parent_guardian_consent.forEach(e=>{
                    e.question.forEach(qes=>{
                        if(qes.label==='parent_guardian_read_acknowledge_disclaimer_url' || qes.label==='parent_guardian_read_and_acknowledge_terms_conditions_and_privacy_policy_url'){
                            if(!qes.client_view.val){
                                this.parent_value.edit_err=true;
                            }
                        }
                    })
                })
            };
        },

        async submit() {
            //編輯設定不填表
            if (this.only_view) {
                return
            }

            if (this.is_edit_setting) {
                //check
                this.checkEditing();
                //裝一包接出去
                let for_back_data=JSON.parse(JSON.stringify(this.handle_data));

                //++++++++++++++++++++++++++++++++++++++++++++++++++
                //handle block status
                if (!this.blockShow.parent) {
                    for_back_data.parent_guardian_consent = [];
                }

                if (!this.blockShow.social) {
                    for_back_data.social_account = [];
                }
                //++++++++++++++++++++++++++++++++++++++++++++++++++
                //設定包再整個FromSetting,所以傳出去CALL API
                let hadErr= this.term_value.edit_err || ( this.parent_value.edit_err && this.blockShow.parent );
                let err_mes = []
                if(this.term_value.edit_err){
                    err_mes.push('Agreements & Disclaimers')
                }
                if(this.parent_value.edit_err && this.blockShow.parent){
                    err_mes.push('Parent / Guardian Consent')
                }
                
                this.$emit('save-form', { data: for_back_data, handle: blockStatus, hadErr: hadErr, err_mes:err_mes });
            }
            // for creator write(這邊填寫都包在這裡，所以submit的api在這裡)(驗證邏輯在frontend_ambassador)
            // else {
  
            // }

        },

        //++++++++++++++++++++++++++++++++++++++++++
        //other
        //++++++++++++++++++++++++++++++++++++++++++
        openList(val) {
            this.is_disabled_click = true;
            setTimeout(() => {
                this.is_disabled_click = false;
            }, 100);


            if (val === 'cus') {
                this.open_list_val.type = 1;
                this.open_list_val.title = this.custom_question_val.title;
                this.open_list_val.list = this.custom_question_val.list;
                this.open_list_val.top = 42;
            } else {
                this.open_list_val.type = 2;
                this.open_list_val.title = this.sections_val.title;
                this.open_list_val.list = this.sections_val.list;
                this.open_list_val.top = 84;
            }

            this.open_list_val.val = this.menu_type === val ? !this.open_list_val.val : true;
            this.menu_type = val;

        },

        selectType(type, id) {
            this.open_list_val.val = false;
            this.is_can_delete = false;
            
            if (type === 2) {
                this.sections_val.list[id].is_add = true;
                //如果是parent，因為有必填選項所以自動打開
                if(this.sections_val.list[id].field==='parent_guardian_consent'){
                    this.editSetting('parent_guardian_consent');
                }
                this.$emit('handle_old_data',{handle_data:this.handle_data,block:this.sections_val.list,tip:'new'});
            } else {
                let index = CustomQuestion.findIndex(item => item.id === id)
                this.get_cus_value = JSON.parse(JSON.stringify(CustomQuestion[index]));
                this.custom_value.is_new = true;
                this.cus_key_refrash += 1;
                this.edit_value.custom_question = true;
            }
        },

        //+++++++++++++++++++++++++++++++++++++++
        //custom question handle 
        //+++++++++++++++++++++++++++++++++++++++
        delCustom(val) {
            if (this.custom_value.is_new) {
                this.edit_value.custom_question = false;
            } else {
                for (let i = 0; i < this.handle_data[val.type].length; i++) {
                    if (this.handle_data[val.type][i].cus_id === val.data.cus_id) {
                        this.handle_data[val.type].splice(i, 1);
                    }
                }
            }

            this.createValuesAndSchema(this.handle_data);
            this.edit_value[val.type] = false;
            this.key_refrash += 1;
            this.$emit('update-data', { field: 'custom_question', val: this.handle_data})
        },

        handleClick(e) {
            if (this.is_disabled_click) {
                this.is_disabled_click = false;
                return
            }

            if (this.$refs.el && !this.$refs.el.contains(e.target)) {
                this.open_list_val.val = false;
            }
        },

        closeLogoModal(val){
            if(val){
                this.data.preview_logo_image_url = val;
                this.handle_data.preview_logo_image_url = val;
            }
            this.showUpload=false;
        }
    },

    async mounted() {
        this.getData();
    },

    created() {
        window.addEventListener('click', this.handleClick);
    },

    destroyed() {
        window.removeEventListener('click', this.handleClick);
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.prog-set-form-wrap {
    @include flexCenter();
    justify-content: center;
    background-color: var(--bg-10);
    height: calc(100vh - 48px);

    .red {
        color: var(--red);
    }

    .flex {
        @include flexCenter;
    }

    .err-edit-btn{
        border:solid 2px var(--red);
    }

    &.only_view {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        background: var(--bg-10);//var(--light-neutral);
        z-index: 1;

        .content .title-big-only{
            margin-bottom:0 !important;
        }

        .edit-btn {
            display: none;
        }

        .only-view-svg {
            width: 24px;
            height: 24px;
            cursor: pointer;
            position: absolute;
            top: 12px;
            right: 24px;
        }
    }

    &.for-fill-in {
        .edit-btn {
            display: none;
        }

        .logo {
            border:none;
            cursor:default;
        }
    }

    .data-list {
        padding: 53px;
        width: 100%;

        @media screen and (max-width: 768px) {
            padding: 16px;
        }
    }

    .logo {
        width: 220px;
        height: 100px;
        margin: auto;
        margin-bottom: 28px;
        @include flexCenter();
        overflow: hidden;
        cursor: pointer;
        border: dashed 2px var(--border);
        position: relative;

        &.logo-only-view{
            border: none;
            pointer-events: none;
        }

        i{
            width:16px;
            height:16px;
            position: absolute;
            right: 0;
            top:4px;

            svg{
                width: 12px;
                height: 12px;
                fill:var(--black-50);
            }
        }

        img {
            width: 100%;
            height: 100px;
            object-fit: contain;
        }
    }

    .from-box {
        margin-bottom: 16px;
        padding: 24px 16px;
        position: relative;
        display: flex;
        background-color: var(--white);

        .line {
            color: var(--blue);
        }

        &:first-child {
            margin-top: 24px;
        }

        &:last-child {
            margin-bottom: 24px;
        }

        .content {
            flex: 1;
            margin-left: 16px;

            .title {
                font: var(--font-demi-24);
                margin-bottom: 12px;
            }

            .text {
                font: var(--font-med-14);
                color: var(--black-90);
                margin-bottom: 6px;
                padding: 0 !important;
            }

            .field-flex-box {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 8px;

                @media screen and (max-width: 768px) {
                    grid-template-columns: 1fr;
                    gap: unset;
                }
            }

            .trem-text {
                margin-bottom: 12px;
            }

            .trem-text-check-box {
                @include flexCenter();

                .ui-checkbox {
                    margin: unset;
                }
            }

            .text-light {
                font: var(--font-med-14);
                color: var(--black-75);
                margin-bottom: 6px;
            }

            .desc {
                font-family: var(--font);
                font-size: 14px;
                color: var(--black-50);

                &.desc-text {
                    color: var(--black-90);
                }
            }

            &.content-cus {
                .ui-input {
                    margin-top: 12px;
                }

                .radio-option .ui-checkbox {
                    margin: unset
                }

                .radio-option,
                .ui-input,
                .checkbox-option {
                    display: flex;
                    align-items: center;
                    padding-bottom: 8px;

                    .ui-checkbox {
                        margin: unset;
                    }
                }
            }

            .question {
                margin: 16px 0;
                border-radius: 8px;

                .label {
                    font: var(--font-med-16);
                    color: var(--black-90);
                    display: inline-block;

                    &.label-req:after {
                        content: ' *';
                        color: var(--alert);
                    }
                }

                .label-text{
                    color:var(--black-75);
                }

                .ui-input {
                    margin: 0;
                    margin-top: 4px;
                    width: 100%;
                    display: unset;
                }

                .ui-dropdown {
                    margin-top: 4px;
                    
                    .ui-dropdown--inner .ui-button span {
                        font-size: 14px;
                    }
                }

                .ui-input--date {
                    margin-top: 4px;
                }

                input,
                select {
                    padding: 10px;
                    height: 36px;
                }
            }

            &.social-box-content {
                .line-box {
                    @include flexCenter();
                    justify-content: space-between;

                    .for-you-url-box {
                        width: 100%;
                    }
                }

                .for-you-url-box-handle {
                    margin-left: 32px;

                    .ui-input--wrap {
                        display: grid;
                        grid-template-columns: 1fr 2fr;
                        gap: 8px;
                    }
                }

                .label {
                    @include flexCenter();
                    width: 120px;
                    margin-right: 8px;
                    gap:4px;

                    .svg-icon {
                        width: 20px;
                        height: 20px;
                        
                    }
                }
            }

            .checkbox-box {
                @include flexCenter();
                align-items: flex-start;
                margin-bottom: 4px;
                cursor: pointer;

                .ui-checkbox {
                    margin: unset;
                }
            }
        }

        .custom-box {
            .question:first-child {
                margin: unset;
            }
        }

        .field-box {
            .ui-input--wrap {
                margin-top: 4px;
            }
        }

        .content-cus {
            .question {
                &:first-child {
                    margin: unset;
                }

                .ui-checkbox,
                .is-disabled {
                    opacity: 1;
                }

                .ui-input {
                    margin-top: 8px;

                    .the-input {
                        margin-top: 8px;
                    }
                }
            }
        }

        &.custom-box-err .question {
            border: solid 1px var(--red);
        }

        &.custom-box-success .question {
            border: solid 1px var(--green);
        }

        .term-box-err {
            border-radius: 8px;
            border: solid 1px var(--red);
            margin: 4px;
        }

        .err-mes {
            @include flexCenter();
            justify-content: flex-end;
            text-align: right;
            color: var(--red);
            margin: 4px 0;
            font-size: 12px;

            .svg-icon {
                height: 10px;
                width: 10px;
                fill: var(--red);
                margin: 0 6px 0 4px;
            }
        }

    }

    .btn-box {
        width: 50%;
        margin: auto;
        position: relative;

        .ui-button {
            margin-bottom: 16px;
        }

        .editList {
            padding: 8px 0;
            width: 100%;
            background: white;
            border: 1px solid #F2F2F2;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            position: absolute;
            z-index: 9;
            right: 0px;
            top: 0;
            transform: translateY(-100%);

            &.menu-type-sec {
                top: 58px;
            }

            .tit {
                padding: 0 9px;
                font: var(--font-med-12);
                color: var(--black-50);
            }

            .item {
                padding: 9px 10px;
                @include flexCenter();
                cursor: pointer;
                color: var(--black-90);
                font: unset;
                font-family: var(--font);
                font-size: 14px;

                &:hover {
                    background: var(--bg-02);
                }

            }
        }
    }

    .submit-btn {
        width: 100%;
        text-align: center;
    }
}
</style>